// removed by extract-text-webpack-plugin
module.exports = {"FiltersBar":"FiltersBar__FiltersBar___dfv8A","withClient":"FiltersBar__withClient___2e-Q6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/FiltersBar/FiltersBar.scss
// module id = 1351
// module chunks = 0